import { axios } from '../../../lib'

export const getAllArticleRules = ({
  expenseGroups = [],
  searchTerm = null,
  pageNumber = null,
  size = null,
  cifs=null,
  orderByList = null
}) => {
  const payload = {
    ...(expenseGroups && { expenseGroups }), 
    ...(searchTerm && { searchTerm }),
    ...(cifs && {cifs}),
    pagination: {
      ...(pageNumber == null || size == null
        ? { pageNumber: null, size: null }
        : { pageNumber, size }),
      ...(orderByList && { orderByList })
    }
  }

  return axios.post('/nomenclatures/rules/articles/paginate', payload)
}
